import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "./customBaseQuery";

export const SearchLocationApiSlice = createApi({
  reducerPath: "searchLocation",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  tagTypes: ["locationData"],
  endpoints: (builder) => ({
    searchLocation: builder.query({
      query: (searchKey) => ({
        url: `/utility/location/${searchKey}`,
        method: "GET"
      }),
      extraOptions: { service: "Utility" }
    })
  })
});

export const { useLazySearchLocationQuery } = SearchLocationApiSlice;
